/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*

*/

import React from 'react';
import { View, StyleSheet, ScrollView, ActivityIndicator } from 'react-native';
import Table from '@components/table/Table';
import Input from '@components/form/Input';
import { currency } from '@global/helpers';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import { isWeb } from '@global/screens';

const COL_WIDTH = 140;

const tableStructureMerged = {
  name: {
    head: 'Brand',
    body: 'brand.name',
  },
  initial_budget: {
    head: 'Initial Budget',
    body: 'initial_budget',
    type: 'currency',
  },
  initial_dpp: {
    head: 'Initial DPP',
    body: 'initial_dpp',
    type: 'currency',
  },
  actual_claim: {
    head: 'Actual Claim',
    body: 'budget_sample',
    type: 'currency',
  },
  dpp: {
    head: 'DPP Actual',
    body: 'dpp',
    type: 'currency',
  },
};

const SkpInternalBrandBudgetTable = ({
  data = [],
  loading = false,
  showLabel = true,
  edit = false,
  isGt = false,
  ChangeActualClaim,
}) => {
  // GT customers see Initial Budget + Initial DPP only — Actual Claim and DPP Actual are hidden.
  const {
    actual_claim: _omitClaim,
    dpp: _omitDpp,
    ...tableStructureGt
  } = tableStructureMerged;
  const tableStructure = isGt ? tableStructureGt : tableStructureMerged;

  return isWeb ? (
    <Table
      testID="skp-external-budget-table"
      structures={tableStructure}
      data={data}
      loading={loading}
      hasNoHide={true}
      showSearch={false}
      showPagination={false}
      showFilter={false}
      isEdit={edit}
      ChangeActualClaim={ChangeActualClaim}
    />
  ) : (
    <View style={styles.container}>
      {showLabel ? (
        <SociollaText
          style={{
            fontSize: edit ? 14 : 11,
            lineHeight: 21,
            fontFamily: 'figtree-regular',
            color: Colors.grey14,
            marginLeft: edit ? 15 : 0,
            fontWeight: edit ? 'bold' : 'normal',
          }}>
          Brand & Nominal Budget
        </SociollaText>
      ) : null}
      {loading ? (
        <ActivityIndicator
          size="large"
          color={Colors.blue0}
          style={{ marginTop: 24 }}
        />
      ) : data.length === 0 ? (
        <View style={styles.emptyContainer}>
          <SociollaText style={styles.emptyText}>No data found</SociollaText>
        </View>
      ) : (
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={true}
          style={{ flex: 1 }}>
          <View>
            {data.map((item, index) => (
              <View
                key={item._id || String(index)}
                style={[
                  styles.tableRow,
                  index === data.length - 1 && styles.lastRow,
                ]}>
                <View style={styles.col}>
                  <SociollaText style={styles.colLabel}>Brand</SociollaText>
                  <SociollaText type="medium" style={styles.colValue}>
                    {item.brand?.name || '-'}
                  </SociollaText>
                </View>
                <View style={styles.col}>
                  <SociollaText style={styles.colLabel}>
                    Initial Budget
                  </SociollaText>
                  <SociollaText type="medium" style={styles.colValue}>
                    {item.initial_budget
                      ? currency(item.initial_budget, true)
                      : '-'}
                  </SociollaText>
                </View>
                <View style={styles.col}>
                  <SociollaText style={styles.colLabel}>
                    Initial DPP
                  </SociollaText>
                  <SociollaText type="medium" style={styles.colValue}>
                    {item.initial_dpp ? currency(item.initial_dpp, true) : '-'}
                  </SociollaText>
                </View>
                {!isGt && (
                  <>
                    <View style={styles.col}>
                      <SociollaText style={styles.colLabel}>
                        Actual Claim
                      </SociollaText>
                      {edit ? (
                        <Input
                          isNumeric
                          containerStyle={{ width: COL_WIDTH - 16 }}
                          value={currency(item.budget_sample, true)}
                          onChangeText={(value) =>
                            ChangeActualClaim(value.replace(/\D/g, ''), item)
                          }
                        />
                      ) : (
                        <SociollaText type="medium" style={styles.colValue}>
                          {item.budget_sample
                            ? currency(item.budget_sample, true)
                            : '-'}
                        </SociollaText>
                      )}
                    </View>
                    <View style={styles.col}>
                      <SociollaText style={styles.colLabel}>
                        DPP Actual
                      </SociollaText>
                      <SociollaText type="medium" style={styles.colValue}>
                        {item.dpp ? currency(item.dpp, true) : '-'}
                      </SociollaText>
                    </View>
                  </>
                )}
              </View>
            ))}
          </View>
        </ScrollView>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
    backgroundColor: Colors.white,
  },
  lastRow: {
    borderBottomWidth: 0,
  },
  col: {
    width: COL_WIDTH,
    paddingRight: 16,
  },
  colLabel: {
    fontSize: 12,
    color: Colors.grey1,
    marginBottom: 6,
  },
  colValue: {
    fontSize: 14,
    color: Colors.black,
  },
  emptyContainer: {
    paddingVertical: 24,
    alignItems: 'center',
  },
  emptyText: {
    fontSize: 13,
    color: Colors.grey1,
  },
});

export default SkpInternalBrandBudgetTable;
